
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { INewsData } from '@/types/news-types'
import BugDialog from '@/views/news/components/bugDialog.vue'

/**
 * 
 * @prop newsList           新闻列表数据
 * @prop searchCb           搜索回调函数
 * @prop isRecommend        是否用于新闻推荐
 * @emit recommend          推荐
 * 
*/
@Component({
    name: 'NewsTable',
    components: {
        BugDialog
    }
})
export default class extends Vue {
    @Prop({ required: true }) private newsList!: INewsData[]
    @Prop({ required: false }) private searchCb!: Function
    @Prop({ default: false }) private isRecommend!: boolean
    @Prop({ default: 'media' }) private mediaType!: String

    private reprintType: any = { 
        unReprint: 0,   // 无
        reprinted: 1,   // 被转载过
        reprint: 2      // 转载他人   
    }
    private statusMap: any = { 
        toFix: 0,     // 待优化
        perfect: 1   // 没问题
    }
    private bugDialogVisible: boolean = false
    private newsId = ''

    private async onTapTitle(data: any) {
        const query = this.isRecommend ? '?recommend=1' : ''
        window.open('/news/' + data.id + query + `?mtype=${this.mediaType}`)
    }

    private onTapMedia(data: any) {
        window.open('/media/' + data.id + '/edit')
    }

    private onTapReporter(data: any) {
        // 跳转到记者详情页
        window.open(`/reporter/${data.id}`, '_blank')
        // const params = {
        //     newsType: 0,    // 全部
        //     searchType: 1,  // 记者
        //     searchQuery: data.name
        // }
        // this.searchCb && this.searchCb(params)
    }

    private onAddBug(data: any) {
        this.newsId = data.id
        this.bugDialogVisible = true
    }

    private onHideBugDialog() {
        this.bugDialogVisible = false
    }

    @Emit('recommend')
    private onRecommend(news: any) {
        return news
    }
}
